// 
export const COUNTRY_CLAUSE_LIST = 'COUNTRY_CLAUSE_LIST';
export const COUNTRY_CLAUSE_REGION_LIST = 'COUNTRY_CLAUSE_REGION_LIST';
export const COUNTRY_CLAUSE_PAGINATION = 'COUNTRY_CLAUSE_PAGINATION';

 